// YearSelect Component
import React from "react";
import Select from "react-select";

interface YearSelectProps {
  start?: number;
  minValue?: number; // New prop to set the minimum value
  onSelect?: (selectedOption: { value: number; label: string } | null) => void;
  styles?: any;
  value?: number;
  isSmall?: boolean;
}

const YearSelect: React.FC<YearSelectProps> = ({
  start = 0,
  minValue = 0,
  onSelect,
  styles,
  value,
  isSmall
}) => {
  const options = Array.from({ length: 61 - start }, (_, index) => {
    const year = index + start;
    return {
      value: year,
      label: `${year}`,
      isDisabled: year < minValue,
    };
  });
  return (
    <Select
      options={options}
      placeholder={`Select`}
      getOptionLabel={(option) => option.label}
      getOptionValue={(option) => String(option.value)}
      onChange={(selectedOption) =>
        onSelect && onSelect(selectedOption as { value: number; label: string } | null)
      }
      value={options.find((option) => option.value === value) || options[0] || null}
    />
  );
};

export default YearSelect;
